import { SuccessResult } from "./SuccessResult";

export const DowngradeSuccessResult: React.FC = () => {
  return <SuccessResult title="Your downgrade is successful" hideConfetti />;
};
